export const EVENT_SLIDE_UP_WINDOW = 'slide_up_window';
export const EVENT_FIND_MY_LOCATION = 'find_my_location';
